<template>
    <div class="card" style="width: 1500px; max-width: 100%;">
        <div class="card-modal" style="overflow: auto; max-height: 700px;">
            <header class="modal-card-head">
                <p class="modal-card-title">Rule Actions</p>
                <button type="button" class="delete" @click="$emit('close')" />
            </header>

            <section class="modal-card-body">
                <table class="table is-bordered is-fullwidth">
                    <tr>
                        <td class="has-text-weight-bold">Rule Category</td>
                        <td class="is-capitalized">{{ category }}</td>
                    </tr>
                    <tr>
                        <td class="has-text-weight-bold">Rule Description</td>
                        <td v-if="rule.type == 'custom'" v-html="$helpers.buildTravelPolicyRuleMessage(rule)"></td>
                        <td v-else>{{ rule.message }}</td>
                    </tr>
                    <tr>
                        <td style="width: 35%;">
                            <div class="has-text-weight-bold">Result visibility</div>
                            How do you want to display a result that violates the rule?
                        </td>
                        <td>
                            {{
                                $helpers.getTravelPolicyViolationVisibilityLabel(
                                    rule.visibility
                                )
                            }}
                        </td>
                    </tr>
                    <tr v-if="rule.visibility == 'show'">
                        <td>
                            <div class="has-text-weight-bold">Approval level</div>
                            What level of approval do you want when a traveler books an option
                            that violates the rule?
                        </td>
                        <td>
                            {{
                                $helpers.getTravelPolicyViolationAction(rule.approvalLevel)
                            }}
                        </td>
                    </tr>
                    <tr v-if="notifications && rule.visibility == 'show'">
                        <td>
                            <div class="has-text-weight-bold">Notifications</div>
                            Where should notifications be sent when a traveller books an option
                            that violates the rule?
                        </td>
                        <td>
                            <ul>
                                <li v-if="notifications.managerViaEmail">
                                    Notify manager via email
                                </li>
                                <li v-if="notifications.managerViaSms">
                                    Notify manager via SMS
                                </li>
                                <li v-if="emailNotifications.length > 0">
                                    Send email to {{ emailNotifications.join() }}
                                </li>
                                <li v-if="smsNotifications.length > 0">
                                    Send SMS to {{ smsNotifications.join() }}
                                </li>
                            </ul>
                        </td>
                    </tr>
                </table>
            </section>

            <footer class="modal-card-foot">
                <b-button label="Close" @click="$emit('close')" />
            </footer>
        </div>
    </div>
</template>

<script>
export default {
    name: "CustomActionsSummaryModal",
    props: {
        rule: {
            type: Object,
            required: true
        }
    },
    computed: {
        category(){
            if(this.rule.type == 'custom'){
                return this.rule.category
            }else{
                return this.rule.type
            }
        },
        message(){
            if(this.rule.type == 'custom'){
                return this.$helpers.buildTravelPolicyRuleMessage(this.rule)
            }else{
                return this.rule.message
            }
        },
        notifications(){
            if(this.rule.type == 'custom'){
                return JSON.parse(this.rule.actionsJson);
            }else{
                return this.rule.notifications
            }
        },
        emailNotifications(){
            if(this.notifications.email){
                return this.notifications.email
            }else{
                return []
            }
        },
        smsNotifications(){
            if(this.notifications.sms){
                return this.notifications.sms
            }else{
                return []
            }
        }
    },
    methods: {


    }
};
</script>

<style scoped>
.is-less-bottom {
    margin-bottom: -20px;
}
</style>
